import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import { Form } from '@/components';

export const StyledContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 6rem;
  gap: 2rem;
`;

export const StyledSaveChangesButton = styled(Button)`
  &&& {
    height: 2.5rem;
    background-color: ${COLORS.YELLOW_PRIMARY};
    border-color: transparent;

    &&&:hover {
      background-color: ${COLORS.YELLOW_PRIMARY};
    }
  }
`;

export const StyledActionButton = styled(Button)`
  &&& {
    height: 2.5rem;
    background-color: ${COLORS.WHITE};
    border-color: ${COLORS.BLACK_PRIMARY};

    &&&:hover {
      background-color: ${COLORS.WHITE};
    }

    &&& svg {
      stroke: ${COLORS.BLACK_PRIMARY};
    }
  }
`;

export const StyledContainerTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  padding-bottom: 10rem;
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('24', '30', 'NORMAL')};
  margin-bottom: 1rem;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      ${pickThemeFontStyles('14', '22', 'NORMAL')};
      width: 100%;
    }
  }
`;

export const StyledHeaderLeftSideBlock = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 20rem;
`;

export const StyledHeaderRightSideBlock = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledProductUrl = styled.a`
  &&& {
    cursor: pointer;
    text-decoration: underline;
    display: block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StyledDivider = styled.div`
  width: 100%;
  border-bottom: 1px solid ${COLORS.BRIGHT_GRAY};
  margin: 1rem 0;
`;

export const StyledForm = styled(Form)`
  width: 100%;
  height: 100%;
`;

export const StyledHintText = styled.div`
  color: ${COLORS.RED};
  margin-bottom: 4rem;
`;
